import React from 'react';
import PropTypes from 'prop-types';
import { confirmable, createConfirmation } from 'react-confirm';
import BasicButton from '../../../../components/BasicButton';
import BasicButtonGroup from '../../../../components/BasicButtonGroup';
import Popup from '../../../../components/Popup';
import UxHelpers from '../../../../helpers/ux-helpers';

const ConfirmDialog = props => {
  const {
    show,
    proceed,
    dismiss,
    cancel,
    title,
    bodyRender,
    textSuccessBtn = 'Ok',
    textCancelBtn = 'Cancel',
    modeless,
    dismissWhenClose,
    hasCloseButton,
    popupStyles,
    className,
  } = props;

  const proceedHandler = data => {
    proceed(data);
    UxHelpers.overflowLock('unlock');
  };

  const cancelHandler = () => {
    cancel();
    UxHelpers.overflowLock('unlock');
  };

  const dismissHandler = () => {
    dismiss();
    UxHelpers.overflowLock('unlock');
  };

  const buttons = (
    <BasicButtonGroup
      groupStyles={{
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <BasicButton
        controlFunc={proceedHandler}
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText={textSuccessBtn}
      />
      <BasicButton
        controlFunc={dismissWhenClose ? dismissHandler : cancelHandler}
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText={textCancelBtn}
      />
    </BasicButtonGroup>
  );

  return (
    show && (
      <Popup
        title={title}
        actions={{
          dismiss,
          cancel,
        }}
        buttonsRender={buttons}
        popupStyles={popupStyles}
        bodyRender={bodyRender}
        modeless={modeless}
        dismissWhenClose={dismissWhenClose}
        hasCloseButton={hasCloseButton}
        className={className}
      />
    )
  );
};

ConfirmDialog.propTypes = {
  title: PropTypes.string,
  bodyRender: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  modeless: PropTypes.bool,
  dismissWhenClose: PropTypes.bool,
  textSuccessBtn: PropTypes.string,
  textCancelBtn: PropTypes.string,
  className: PropTypes.string,
};

export default createConfirmation(confirmable(ConfirmDialog));
